import React, { useState } from 'react'
import { Container, Form, Row, Col, } from 'react-bootstrap';
import { connect } from "react-redux";
import { useEffect } from 'react';
import _ from "lodash";
import { AddEmployeeTypeApi } from './employeeTypeAction'
import { setHeading } from '../../../accounts/account.actions';
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const EmployeeType = (props) => {
    const [employeeTypeName, setEmployeeTypeName] = useState();
    const [employeeTypeDescription, setEmployeeTypeDescription] = useState();

    function uploadEmployeeType() {
        props.AddEmployeeTypeApi({
            employeeType: _.upperCase(employeeTypeName),
            description: _.upperCase(employeeTypeDescription),
        },
            showSuccessAlert,
            showErrorAlert,
        );
        clearStates()
    }
    const clearStates = () => {
        setEmployeeTypeName();
        setEmployeeTypeDescription();
    }

    useEffect(() => {
        props.setHeading("Employee Type Add")
    }, []);

    return (
        <>
            {(props.isAddingEmployeeTypeData) ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana" >
                                    <Form.Label><b>Employee Type *</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Employee Type"
                                        onChange={(e) => setEmployeeTypeName(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label> <b>Employee Type Description</b></Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder="Employee Type Description"
                                        onBlur={(e) => setEmployeeTypeDescription(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="sendDiv">
                            {_.isEmpty(employeeTypeName) ? (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                            ) : (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => { uploadEmployeeType(); }}> SAVE </Button>
                            )}
                        </div>

                    </Form>
                </Container>
            )}
        </>
    );
}
const mapDispatchToProps = (dispatch) => {
    return {
        AddEmployeeTypeApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddEmployeeTypeApi(data, showSuccessAlert, showErrorAlert)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingEmployeeTypeData: state.EmployeeTypeReducer.isAddingEmployeeTypeData,
});


export default connect(mapStateToProps, mapDispatchToProps)(EmployeeType);